module.exports = {
  available: false,
  slug: "cancun",
  name: "Cancun",
  year: 2018,
  region: "Mexico",
  country: "Mexico",
  location: "Cancun, Mexico",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: true,
  useHawaiiPricing: false,
  useHawaiiPhoneGate: false,
  soldOutPercent: 100,
  soldOutPercentHawaii: 100,
  soldOutReferralTrip: 'kauai2019',
  soldOutReferralText: 'Kauai Trip Added',
  banners: [],
  thinBar1: '',
  thinBar2: '',
  saleEndsAt: '',
  onLocationPricingAvailable: true,
  onLocationPricingCutoff: "2018-06-21T01:00:00",
  onLocationMessage: "",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: false,
  requireFirstNameForNewsletterFooter: true,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: true,
  dates: "May 13-19, 2018",
  timeZone: "EST",
  startTime: "8:00 PM (EST)",
  checkInDay: "Sunday",
  checkInDate: "May 13, 2018",
  checkInTime: "3:00 PM (EST)",
  arrivePriorTo: "5:30 PM (EST)",
  checkOutDay: "Saturday",
  checkOutDate: "May 19, 2018",
  checkOutTime: "12:00 PM (EST)",
  disableMonthlyPaymentOption: false,
  maxSubMonths: 9,
  useMaxSubMonthsCutoff: "09-29-2017",
  availabilityCutoff: "05-11-2018",
  departureAirport: "Cancun",
  departureAirCode: "CUN",
  venue: "The Ritz-Carlton, Cancun",
  venueSlug: "ritz-cancun",
  homeVideoId: 218362797,
  requestBrochureCategoryID: "34b7e4d1b0",
  finalDetailsFormHash: "zuys5o51gk4rkc",
  mapUrl: "https://www.google.com/maps?q=The+Ritz-Carlton,+Cancun&um=1&ie=UTF-8&sa=X&ved=0ahUKEwi2-OisuObaAhUK72MKHZOhDtAQ_AUICigB",
  perks: [
    "7 Days / 6 Nights The Ritz-Carlton, Cancun Accommodations",
    "Premium WiFi Access",
    "Complimentary Valet Parking",
    "Porterage Fees (Baggage Handling)",
    "Daily Housekeeping Gratuities",
    "Everlasting Tours On-Location Staff",
    "$25 will be contributed to the Love Song Foundation",
    "Entertainment Wristbands ($500 value per person, included!)"
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists"
  ],
  lineup: [
    {
    key: "jeremycamp",
    kind: "artist",
    name: "Jeremy Camp",
    nameFirst: "Jeremy",
    nameLast: "Camp"
    }, {
    key: "matthewwest",
    kind: "artist",
    name: "Matthew West",
    nameFirst: "Matthew",
    nameLast: "West",
    }, {
    key: "drgarychapman",
    kind: "speaker",
    name: "Dr. Gary Chapman",
    nameFirst: "Dr. Gary",
    nameLast: "Chapman",
    book: "5-love-languages"
    }, {
    key: "newsboys",
    avatar: "michaeltait",
    kind: "artist",
    name: "Michael Tait of Newsboys",
    nameFirst: "Michael Tait",
    nameLast: "of Newsboys"
    }, {
    key: "thirdday",
    kind: "artist",
    name: "Mac of Third Day",
    nameFirst: "Mac of",
    nameLast: "Third Day"
    }, {
    key: "troytyler",
    kind: "speaker",
    name: "Troy Tyler",
    nameFirst: "Troy",
    nameLast: "Tyler"
    }
  ],
  itinerary: [
    {
    name: "Sun",
    body: "\
      <p>\
      <strong>Day 1 | May 13</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>\
        Resort Check-in & Love Song Registration\
      </strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>\
        Grand Opening with Troy Tyler<br />\
        & Mac of Third Day Performance\
      </strong>\
      </p>\
    "
    }, {
    name: "Mon",
    body: "\
      <p>\
      <strong>Day 2 | May 14</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Worship & Dr. Gary Chapman (Session 1 & 2)</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>Free Time</strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>Optional Activity – Date Night in Paradise*</strong>\
      </p>\
    "
    }, {
    name: "Tue",
    body: "\
      <p>\
      <strong>Day 3 | May 15</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Worship & Dr. Gary Chapman (Session 3 & 4)</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>Free Time</strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>Optional Activity – Starry Nights Social*</strong>\
      </p>\
    "
    }, {
    name: "Wed",
    body: "\
      <p>\
      <strong>Day 4 | May 16</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Worship, Devotion, & Communion</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>Free Time</strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>\
        Matthew West Performance &<br />\
        Michael Tait of Newsboys Performance\
      </strong>\
      </p>\
    "
    }, {
    name: "Thu",
    body: "\
      <p>\
      <strong>Day 5 | May 17</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Free Time</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>Optional Activity – Love Song Interactive*</strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>Free Time</strong>\
      </p>\
    "
    }, {
    name: "Fri",
    body: "\
      <p>\
      <strong>Day 6 | May 18</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Worship, Devotion, & Communion</strong>\
      </p>\
      <p>\
      Afternoon:<br />\
      <strong>Free Time</strong>\
      </p>\
      <p>\
      Evening:<br />\
      <strong>\
        Jeremy Camp Performance & Farewell\
      </strong>\
      </p>\
    "
    }, {
    name: "Sat",
    body: "\
      <p>\
      <strong>Day 7 | May 19</strong>\
      </p>\
      <p>\
      Morning:<br />\
      <strong>Resort Checkout</strong>\
      </p>\
    "
    }
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [
  ],
  rooms: {
    "ocean-view": {
      key: "ocean-view",
      name: "Ocean View",
      kind: "room",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 3398
      },
      extraNightPrices: {
        default: 399,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description: "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…"
    },
    "ocean-view-king": {
      key: "ocean-view-king",
      name: "Ocean View - King Guaranteed",
      kind: "room",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 3698
      },
      extraNightPrices: {
        default: 399,
      },
      soldOut: true,
      popular: true,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description: "Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…"
    },
    "oceanfront": {
      key: "oceanfront",
      name: "Ocean Front",
      kind: "room",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 3898
      },
      extraNightPrices: {
        default: 399,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description: "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…"
    },
    "oceanfront-king": {
      key: "oceanfront-king",
      name: "Ocean Front - King Guaranteed",
      kind: "room",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 4298
      },
      extraNightPrices: {
        default: 499,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "Sold Out",
      image: "/images/rooms/cancun-oceanfront-king.jpg",
      header: "/images/rooms/cancun-oceanfront-king.jpg",
      description: "Spacious 435 sqft. guest room, one King (bedding guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…"
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 5598
      },
      extraNightPrices: {
        default: 599,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description: "Elegant 876 sqft. suite, one King, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, coffee maker, and more…"
    },
    "oceanfront-suite": {
      key: "oceanfront-suite",
      name: "Ocean Front Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 5998
      },
      extraNightPrices: {
        default: 599,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "Sold Out",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description: "Elegant 876 sqft. suite, one King, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…"
    },
    "club-ocean-view-suite": {
      key: "club-ocean-view-suite",
      name: "Club Ocean View Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 8598
      },
      extraNightPrices: {
        default: 899,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description: "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…"
    },
    "club-oceanfront-suite": {
      key: "club-oceanfront-suite",
      name: "Club Ocean Front Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 8998
      },
      extraNightPrices: {
        default: 899,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description: "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…"
    },
    "club-master-suite": {
      key: "club-master-suite",
      name: "Club Master Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 9998
      },
      extraNightPrices: {
        default: 999,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description: "Elegant 876 sqft. suite, one King, located on Club Level with access, three balconies with sweeping ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…"
    },
    "ritz-carlton-suite": {
      key: "ritz-carlton-suite",
      name: "Ritz-Carlton Suite",
      kind: "suite",
      trip: "cancun",
      upsell: false,
      prices: {
        default: 14998
      },
      extraNightPrices: {
        default: 1499,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/cancun-ritz.jpg",
      header: "/images/rooms/cancun-ritz-header.jpg",
      description: "Extravagant 2460 sqft. suite, one King, Club Level access, located at highest level of resort, personal terrace with chaise lounges overlooking the ocean, oversized jacuzzi on terrace, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…"
    }
  }
}



// WEBPACK FOOTER //
// ./lib/trips/cancun.js